export type MedicoUserAccountGateState = 'pending' | 'ready' | 'local-setup' | 'session-error';

export type MedicoUserAccountGateView = 'children' | 'local-setup' | 'session-error' | 'loading';

/**
 * MedicoUserAccount の表示分岐。
 * `confirmedReadyWithSession` は「対象パスで一度セッション完備の ready を確認した」場合のみ true。
 * 別パスから遷移してきた直後の stale ready を session-error と誤判定しないために使う。
 */
export function resolveMedicoUserAccountGateView(input: {
  requiresAnonymousAccount: boolean;
  gateState: MedicoUserAccountGateState;
  sessionComplete: boolean;
  confirmedReadyWithSession: boolean;
}): MedicoUserAccountGateView {
  const canRenderChildren = !input.requiresAnonymousAccount || (input.gateState === 'ready' && input.sessionComplete);
  if (canRenderChildren) {
    return 'children';
  }

  if (input.gateState === 'local-setup') {
    return 'local-setup';
  }

  const sessionLostAfterReady =
    input.requiresAnonymousAccount &&
    input.gateState === 'ready' &&
    !input.sessionComplete &&
    input.confirmedReadyWithSession;

  if (input.gateState === 'session-error' || sessionLostAfterReady) {
    return 'session-error';
  }

  return 'loading';
}
